import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listWarehouse } from '@/api/warehouse.js';
import YTable from '@/views/components/table/index.vue';
import SelectProductComponent from '../../components/product/stock.vue';
import { createAgentReturn, updateAgentReturn, updateAgentReturnStatus, listAgentReturnInfo, deleteAgentReturn, createAgentReturnInfo, createAgentReturnInfos, updateAgentReturnInfo, deleteAgentReturnInfoByIds, findAgentReturn } from '@/api/agent_return.js';
import { listDealerUserManufacturer } from '@/api/manufacturer.js';
import { mapActions } from 'vuex';
import dayjs from 'dayjs';
import { parseBarCode } from '@/api/product';
import { listStockMain } from '@/api/stock.js';
import ExcelImportComponent from './components/import/excel.vue';
import PrintComponent from './components/print/index.vue';
export default {
  props: {
    id: {
      type: String,
      required: false
    }
  },
  components: {
    YTable: YTable,
    ExcelImportComponent: ExcelImportComponent,
    PrintComponent: PrintComponent,
    SelectProductComponent: SelectProductComponent
  },
  data: function data() {
    return {
      form: {},
      formRules: {
        manufacturerId: [{
          required: true,
          message: '请选择客户',
          trigger: ['change', 'blur']
        }],
        warehouseId: [{
          required: true,
          message: '请选择退货仓库',
          trigger: ['change', 'blur']
        }],
        returnDate: [{
          required: true,
          message: '请选择退货日期',
          trigger: ['change', 'blur']
        }],
        returnedBy: [{
          required: true,
          message: '请选择退货人',
          trigger: ['change', 'blur']
        }]
      },
      detailForm: {
        page: 1,
        pageSize: 10,
        total: 0,
        data: []
      },
      detailFormRules: {},
      detailList: [],
      detailLoading: false,
      detailRowIndex: -1,
      orderInfo: {},
      formLoading: false,
      showScanInputBox: false,
      scanBarCode: null,
      tipMessage: null,
      lastProduct: null,
      columns: [{
        prop: 'productNumber',
        label: '产品编号',
        width: 150,
        checked: true,
        fixedWidth: true
      }, {
        prop: 'productName',
        label: '产品名称',
        width: 150,
        checked: true,
        fixedWidth: true
      }, {
        prop: 'specificationModel',
        label: '规格型号',
        width: 150,
        checked: true,
        fixedWidth: true
      }, {
        prop: 'batchNumber',
        label: '产品批号',
        width: 100,
        checked: true,
        fixedWidth: true
      }, {
        prop: 'unit',
        label: '单位',
        width: 100,
        checked: true,
        fixedWidth: true
      }, {
        prop: 'returnQuantity',
        label: '退货数量',
        width: 100,
        checked: true,
        slot: 'returnQuantity',
        fixedWidth: true
      }, {
        prop: 'afterTaxPrice',
        label: '单价',
        width: 100,
        checked: true,
        fixedWidth: true
      }, {
        prop: 'sumPrice',
        label: '退货金额',
        width: 100,
        checked: true,
        fixedWidth: true
      }, {
        prop: 'normalQuantity',
        label: '虚拟库存数量',
        width: 100,
        checked: true,
        fixedWidth: true
      }, {
        prop: 'registrationNumber',
        label: '注册证号',
        width: 150,
        checked: true,
        fixedWidth: true
      }, {
        prop: 'manufacturer',
        label: '生产厂家',
        width: 150,
        checked: true
      }, {
        prop: 'remark',
        label: '备注',
        width: 150,
        checked: true,
        slot: 'remark',
        fixedWidth: true
      }],
      timestamp: new Date().valueOf(),
      cacheName: '',
      userList: [],
      warehouseList: [],
      manufacturerList: [],
      profile: {}
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.cacheName = this.$route.name + '-detail-table';
    this.init();
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/db', ['database', 'databaseClear'])), {}, {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, db;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                _context.next = 3;
                return _this.database({
                  user: true
                });

              case 3:
                db = _context.sent;
                that.profile = db.get('profile').value();
                _context.next = 7;
                return that.loadManufacturer();

              case 7:
                _context.next = 9;
                return that.loadWarehouse();

              case 9:
                if (!Number(that.id)) {
                  _context.next = 16;
                  break;
                }

                _context.next = 12;
                return that.orderEdit();

              case 12:
                _context.next = 14;
                return that.loadDetail();

              case 14:
                _context.next = 18;
                break;

              case 16:
                _context.next = 18;
                return that.orderCreate();

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadDetail: function loadDetail() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, form;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;
                form = JSON.parse(JSON.stringify(that.detailForm));
                form.pageSize = 9999;
                form.consignmentReturnId = that.form.id;
                delete form.data;
                that.detailForm.data = [];
                _context2.next = 8;
                return listAgentReturnInfo(form).then(function (res) {
                  res.list.map(function (row) {
                    that.detailForm.data.push({
                      id: row.ID,
                      productName: row.name,
                      productNumber: row.productNumber,
                      mainId: row.mainId,
                      specsId: row.specsId,
                      afterTaxPrice: row.afterTaxPrice,
                      sumPrice: row.sumPrice,
                      returnQuantity: row.returnQuantity,
                      inventoryId: row.inventoryId,
                      specificationModel: row.specs.specificationModel,
                      barCode: row.specs.specificationModel,
                      batchNumber: row.inventory.batch_number,
                      unit: row.specs.unit,
                      stockQuantity: row.inventory.stock_quantity,
                      normalQuantity: row.inventory.normalQuantity,
                      registrationNumber: row.inventory.registrationNumber,
                      manufacturer: row.main.manufacturer,
                      trackingCode: row.inventory.trackingCode || null,
                      remark: row.remark
                    });
                  });
                  that.detailForm.total = res.total;
                }).catch(function (e) {
                  console.log(e);
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    loadWarehouse: function loadWarehouse() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this3;
                that.warehouseList = [];
                _context3.next = 4;
                return listWarehouse({
                  page: 1,
                  pageSize: 9999,
                  isVirtualWarehouse: 3
                }).then(function (res) {
                  that.warehouseList = res.list;
                }).catch(function (e) {});

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    orderCreate: function orderCreate() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;
                that.form = {
                  manufacturerId: null,
                  manufacturerName: null,
                  warehouseId: null,
                  warehouseName: null,
                  returnedBy: that.profile.nickName,
                  returnDate: dayjs().format('YYYY-MM-DD'),
                  status: 1,
                  sourceType: 2,
                  remark: null
                };
                that.orderInfo.returnedBy = that.profile.nickName;
                console.log('that.orderInfo.nickName', that.orderInfo.nickName);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    orderEdit: function orderEdit() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5;
                _context5.next = 3;
                return findAgentReturn({
                  id: Number(that.id) || that.form.id
                }).then(function (res) {
                  var row = res.reerpConsignReturn;
                  that.orderInfo = row;
                  that.form = {
                    id: row.ID,
                    warehouseId: row.warehouseId,
                    warehouseName: row.warehouseName,
                    manufacturerId: row.manufacturerId,
                    manufacturerName: row.manufacturerName,
                    returnedBy: row.returnedBy,
                    returnDate: row.returnDate,
                    status: row.status,
                    sourceType: row.sourceType,
                    remark: row.remark
                  }; // 如果是驳回的状态，则将其暂时标记为暂存状态，为了实现订单的重新编辑

                  // 如果是驳回的状态，则将其暂时标记为暂存状态，为了实现订单的重新编辑
                  if (that.form.status === -2) {
                    that.form.status = 1;
                  } // 如果是ERP的订单，只能查看不能修改，所以将订单状态暂时标记为已记账状态。


                  // 如果是ERP的订单，只能查看不能修改，所以将订单状态暂时标记为已记账状态。
                  if (that.form.sourceType === 1) {
                    that.form.status = 4;
                  }
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    loadManufacturer: function loadManufacturer() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this6;
                query = {
                  page: 1,
                  pageSize: 9999
                };
                _context6.next = 4;
                return listDealerUserManufacturer(query).then(function (res) {
                  that.manufacturerList = res.list;
                }).catch(function (e) {});

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 显示、隐藏扫码录入框
    toScanInput: function toScanInput() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var that;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                that = _this7;
                _context7.prev = 1;

                if (that.form.id) {
                  _context7.next = 5;
                  break;
                }

                _context7.next = 5;
                return that.formStorage(1);

              case 5:
                that.showScanInputBox = !that.showScanInputBox;

                if (that.showScanInputBox) {
                  that.$nextTick(function () {
                    that.$refs.scanInputBoxRef.focus();
                  });
                }

                _context7.next = 12;
                break;

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](1);
                that.$message.error(_context7.t0.message);

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[1, 9]]);
      }))();
    },
    toImportFromExcel: function toImportFromExcel() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var that;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                that = _this8;
                _context8.prev = 1;

                if (that.form.id) {
                  _context8.next = 5;
                  break;
                }

                _context8.next = 5;
                return that.formStorage(1);

              case 5:
                that.$refs.ExcelImportComponentRef.init({
                  manufacturerId: that.form.manufacturerId
                });
                _context8.next = 11;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](1);
                that.$message.error(_context8.t0.message);

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[1, 8]]);
      }))();
    },
    toSelectProduct: function toSelectProduct() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var that;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                that = _this9;
                _context9.prev = 1;

                if (that.form.id) {
                  _context9.next = 5;
                  break;
                }

                _context9.next = 5;
                return that.formStorage(1);

              case 5:
                that.$refs.SelectProductComponentRef.init({
                  manufacturerId: that.form.manufacturerId
                });
                _context9.next = 11;
                break;

              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9["catch"](1);
                that.$message.error(_context9.t0.message);

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[1, 8]]);
      }))();
    },
    toSaveAll: function toSaveAll() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var that;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                that = _this10;
                _context11.next = 3;
                return new Promise(function (resolve, reject) {
                  var addList = [];
                  that.detailForm.data.map( /*#__PURE__*/function () {
                    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(row) {
                      return regeneratorRuntime.wrap(function _callee10$(_context10) {
                        while (1) {
                          switch (_context10.prev = _context10.next) {
                            case 0:
                              if (!row.id) {
                                addList.push({
                                  afterTaxPrice: row.afterTaxPrice,
                                  consignmentReturnId: that.form.id,
                                  inventoryId: row.inventoryId,
                                  mainId: row.mainId,
                                  name: row.productName,
                                  productNumber: row.productNumber,
                                  returnQuantity: row.returnQuantity,
                                  specsId: row.specsId,
                                  remark: row.remark
                                });
                              }

                            case 1:
                            case "end":
                              return _context10.stop();
                          }
                        }
                      }, _callee10);
                    }));

                    return function (_x) {
                      return _ref.apply(this, arguments);
                    };
                  }());

                  try {
                    if (addList.length > 0) {
                      createAgentReturnInfos(addList);
                    }

                    resolve();
                  } catch (e) {
                    reject(new Error(e.message));
                  }
                });

              case 3:
                return _context11.abrupt("return", _context11.sent);

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    toSaveOne: function toSaveOne(row) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var that;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                that = _this11;
                _context12.prev = 1;
                _context12.next = 4;
                return that.saveOne(row);

              case 4:
                _context12.next = 9;
                break;

              case 6:
                _context12.prev = 6;
                _context12.t0 = _context12["catch"](1);
                that.$message.error(_context12.t0.message);

              case 9:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, null, [[1, 6]]);
      }))();
    },
    saveOne: function saveOne(row) {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var that;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                that = _this12;
                _context13.next = 3;
                return new Promise(function (resolve, reject) {
                  try {
                    var form = {
                      id: row.id,
                      afterTaxPrice: row.afterTaxPrice,
                      consignmentReturnId: that.form.id,
                      inventoryId: row.inventoryId,
                      mainId: row.mainId,
                      name: row.productName,
                      productNumber: row.productNumber,
                      returnQuantity: row.returnQuantity,
                      specsId: row.specsId,
                      remark: row.remark
                    };

                    if (that.form.id) {
                      if (row.id) {
                        updateAgentReturnInfo(form);
                      } else {
                        createAgentReturnInfo(form);
                      }
                    }

                    resolve();
                  } catch (e) {
                    reject(new Error(e.message));
                  }
                });

              case 3:
                return _context13.abrupt("return", _context13.sent);

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))();
    },
    toRowRemove: function toRowRemove() {
      var that = this;
      var rows = that.detailForm.data.slice((that.detailForm.page - 1) * that.detailForm.pageSize, that.detailForm.page * that.detailForm.pageSize);
      var row = JSON.parse(JSON.stringify(rows[that.detailRowIndex]));
      that.detailForm.data.splice(that.detailForm.data.indexOf(rows[that.detailRowIndex]), 1);
      that.detailForm.total = that.detailForm.data.length;
      rows = that.detailForm.data.slice((that.detailForm.page - 1) * that.detailForm.pageSize, that.detailForm.page * that.detailForm.pageSize);

      if (rows.length > 1) {
        if (that.detailRowIndex > rows.length - 1) {
          that.detailRowIndex = rows.length - 1;
        }

        console.log('that.detailRowIndex1', that.detailRowIndex);
        var currentRow = rows[that.detailRowIndex];
        that.$refs.dragTableRef.setCurrentRow(currentRow, true);
      } else {
        console.log('that.detailRowIndex2', that.detailRowIndex);
        that.detailRowIndex = 0;
        that.detailForm.page = that.detailForm.page - 1;

        if (that.detailForm.page < 1) {
          that.detailForm.page = 1;
        }

        rows = that.detailForm.data.slice((that.detailForm.page - 1) * that.detailForm.pageSize, that.detailForm.page * that.detailForm.pageSize);

        if (rows.length === 0) {
          that.detailRowIndex = -1;
        } else {
          that.detailRowIndex = rows.length - 1;
        }
      }

      if (that.detailRowIndex >= 0) {
        rows = that.detailForm.data.slice((that.detailForm.page - 1) * that.detailForm.pageSize, that.detailForm.page * that.detailForm.pageSize);
        var _currentRow = rows[that.detailRowIndex];
        that.$refs.dragTableRef.setCurrentRow(_currentRow, true);
      }

      if (row.id) {
        deleteAgentReturnInfoByIds({
          ids: [row.id]
        });
      }
    },
    checkStockQuantity: function checkStockQuantity() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var that;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                that = _this13;
                return _context14.abrupt("return", new Promise(function (resolve, reject) {
                  var result = true;
                  that.detailForm.data.map(function (row) {
                    if (row.returnQuantity > row.normalQuantity) {
                      // 查找该记录位置
                      var findIndex = that.detailForm.data.indexOf(row); // 翻页

                      // 翻页
                      var page = Math.ceil((findIndex + 1) / that.detailForm.pageSize);
                      that.detailForm.page = page;
                      var rows = that.detailForm.data.slice((that.detailForm.page - 1) * that.detailForm.pageSize, that.detailForm.page * that.detailForm.pageSize);
                      that.detailRowIndex = rows.indexOf(row);
                      result = false;
                      that.$nextTick(function () {
                        that.$refs.dragTableRef.setCurrentRow(row, true);
                        reject(new Error('产品【' + row.productName + '】的库存数量不足'));
                      });
                    }
                  });

                  if (result) {
                    resolve();
                  }
                }));

              case 2:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }))();
    },
    toFormStorage: function toFormStorage() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var that;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                that = _this14;
                _context15.prev = 1;
                _context15.next = 4;
                return that.checkStockQuantity();

              case 4:
                _context15.next = 6;
                return that.formStorage(1);

              case 6:
                that.$notify.success('暂存成功');
                _context15.next = 12;
                break;

              case 9:
                _context15.prev = 9;
                _context15.t0 = _context15["catch"](1);
                that.$message.error(_context15.t0.message);

              case 12:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, null, [[1, 9]]);
      }))();
    },
    formStorage: function formStorage(status) {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var that;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                that = _this15;
                return _context17.abrupt("return", new Promise(function (resolve, reject) {
                  that.$refs.form.validate( /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(valid, err) {
                      var form, findWarehouseRow, findManuRow, item;
                      return regeneratorRuntime.wrap(function _callee16$(_context16) {
                        while (1) {
                          switch (_context16.prev = _context16.next) {
                            case 0:
                              if (!valid) {
                                _context16.next = 25;
                                break;
                              }

                              that.formLoading = true;
                              _context16.prev = 2;
                              form = JSON.parse(JSON.stringify(that.form));
                              findWarehouseRow = that.warehouseList.find(function (item) {
                                return item.ID === that.form.warehouseId;
                              });
                              form.warehouseName = findWarehouseRow.name;
                              form.status = status;
                              findManuRow = that.manufacturerList.find(function (item) {
                                return item.ID === that.form.manufacturerId;
                              });
                              that.form.manufacturerName = findManuRow.name;

                              if (!form.id) {
                                _context16.next = 15;
                                break;
                              }

                              _context16.next = 12;
                              return updateAgentReturn(form);

                            case 12:
                              resolve();
                              _context16.next = 17;
                              break;

                            case 15:
                              _context16.next = 17;
                              return createAgentReturn(form).then(function (res) {
                                that.form.id = res.ID;
                                resolve();
                              });

                            case 17:
                              _context16.next = 22;
                              break;

                            case 19:
                              _context16.prev = 19;
                              _context16.t0 = _context16["catch"](2);
                              reject(new Error(_context16.t0.message));

                            case 22:
                              that.formLoading = false;
                              _context16.next = 27;
                              break;

                            case 25:
                              item = err[Object.keys(err)[0]][0];
                              reject(new Error(item.message));

                            case 27:
                            case "end":
                              return _context16.stop();
                          }
                        }
                      }, _callee16, null, [[2, 19]]);
                    }));

                    return function (_x2, _x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                }));

              case 2:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }))();
    },
    toFormSubmit: function toFormSubmit() {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var that, updateForm;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                that = _this16;
                _context18.prev = 1;
                _context18.next = 4;
                return that.checkStockQuantity();

              case 4:
                _context18.next = 6;
                return that.formStorage(1);

              case 6:
                updateForm = {
                  id: that.form.id,
                  status: -1
                };
                _context18.next = 9;
                return updateAgentReturnStatus(updateForm);

              case 9:
                _context18.next = 11;
                return that.orderEdit();

              case 11:
                that.$notify.success('提交成功');
                _context18.next = 17;
                break;

              case 14:
                _context18.prev = 14;
                _context18.t0 = _context18["catch"](1);
                that.$message.error(_context18.t0.message);

              case 17:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, null, [[1, 14]]);
      }))();
    },
    toUnFormSubmit: function toUnFormSubmit() {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        var that;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                that = _this17;
                that.$confirm('确定要撤销提交吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
                  var updateForm;
                  return regeneratorRuntime.wrap(function _callee19$(_context19) {
                    while (1) {
                      switch (_context19.prev = _context19.next) {
                        case 0:
                          _context19.prev = 0;
                          updateForm = {
                            id: that.form.id,
                            status: 1
                          };
                          _context19.next = 4;
                          return updateAgentReturnStatus(updateForm);

                        case 4:
                          _context19.next = 6;
                          return that.orderEdit();

                        case 6:
                          _context19.next = 10;
                          break;

                        case 8:
                          _context19.prev = 8;
                          _context19.t0 = _context19["catch"](0);

                        case 10:
                        case "end":
                          return _context19.stop();
                      }
                    }
                  }, _callee19, null, [[0, 8]]);
                })));

              case 2:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }))();
    },
    toOrderPrint: function toOrderPrint() {
      var that = this;
      that.$refs.PrintComponentRef.init(that.form.id);
    },
    toOrderDelete: function toOrderDelete() {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var that;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                that = _this18;
                that.$confirm('此操作将删除该订单, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(function () {
                  deleteAgentReturn({
                    id: that.form.id
                  }).then(function (res) {
                    that.$notify({
                      message: '删除成功',
                      type: 'success'
                    });
                    that.returnList();
                  });
                });

              case 2:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }))();
    },
    returnList: function returnList() {
      var that = this;
      that.$store.dispatch('d2admin/page/close', {
        tagName: that.$route.fullPath
      });
      setTimeout(function () {
        that.$router.push({
          name: 'order-consign-return-index'
        });
      });
    },
    detailFormPageChange: function detailFormPageChange(page) {
      var that = this;
      that.detailForm.page = page;
      var rows = that.detailForm.data.slice((that.detailForm.page - 1) * that.detailForm.pageSize, that.detailForm.page * that.detailForm.pageSize);

      if (that.detailRowIndex > rows.length - 1) {
        that.detailRowIndex = rows.length - 1;
        var currentRow = rows[that.detailRowIndex];
        that.$refs.dragTableRef.setCurrentRow(currentRow, true);
      }
    },
    detailFormSizeChange: function detailFormSizeChange(pageSize) {
      var that = this;
      that.detailForm.pageSize = pageSize;
      that.detailForm.page = 1;
    },
    stockAddToList: function stockAddToList(rows) {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        var that, repeatRows, newRows;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                that = _this19;
                _context23.prev = 1;
                repeatRows = [];
                newRows = 0;
                rows.map(function (row) {
                  var findRow = that.detailForm.data.find(function (item) {
                    return row.inventoryId === item.inventoryId && row.batchNumber === item.batchNumber && row.trackingCode === item.trackingCode;
                  });

                  if (findRow) {
                    if (findRow.returnQuantity >= findRow.normalQuantity) {
                      throw new Error('库存数量不足');
                    }

                    findRow.returnQuantity += row.returnQuantity;
                    console.log('findRow.returnQuantity', findRow.returnQuantity);
                    findRow.sumPrice = Number(Number(findRow.returnQuantity * findRow.afterTaxPrice).toFixed(2));
                    repeatRows.push(findRow.productName + '重复添加，数量+' + row.returnQuantity);
                    that.saveOne(findRow);
                  } else {
                    newRows += row.returnQuantity;
                    that.detailForm.data.push(_objectSpread({
                      id: null
                    }, row));
                  }
                });

                if (!(newRows > 0)) {
                  _context23.next = 11;
                  break;
                }

                _context23.next = 8;
                return that.toSaveAll();

              case 8:
                that.$notify.success({
                  title: '添加产品',
                  dangerouslyUseHTMLString: true,
                  message: '新增加' + newRows + '个产品' + (repeatRows.length > 0 ? '<br>' + repeatRows.join('<br>') : '')
                });
                _context23.next = 12;
                break;

              case 11:
                that.$notify.success({
                  title: '添加产品',
                  dangerouslyUseHTMLString: true,
                  message: repeatRows.length > 0 ? '<br>' + repeatRows.join('<br>') : ''
                });

              case 12:
                setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
                  return regeneratorRuntime.wrap(function _callee22$(_context22) {
                    while (1) {
                      switch (_context22.prev = _context22.next) {
                        case 0:
                          _context22.next = 2;
                          return that.loadDetail();

                        case 2:
                        case "end":
                          return _context22.stop();
                      }
                    }
                  }, _callee22);
                })), 500);
                that.timestamp = new Date().valueOf();
                _context23.next = 19;
                break;

              case 16:
                _context23.prev = 16;
                _context23.t0 = _context23["catch"](1);
                that.$message.error(_context23.t0.message);

              case 19:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, null, [[1, 16]]);
      }))();
    },
    manufacturerIdChange: function manufacturerIdChange(val) {
      var that = this;
      var findRow = that.manufacturerList.find(function (item) {
        return item.ID === val;
      });

      if (findRow) {
        that.form.manufacturerName = findRow.name;
      } else {
        that.form.manufacturerName = null;
      }
    },
    returnSumQuantity: function returnSumQuantity() {
      var that = this;
      var num = 0;
      that.detailForm.data.map(function (row) {
        num += row.returnQuantity;
      });
      return num;
    },
    returnSumAmount: function returnSumAmount() {
      var that = this;
      var num = 0;
      that.detailForm.data.map(function (row) {
        num += row.returnQuantity * row.afterTaxPrice;
      });
      return num.toFixed(2);
    },
    detailRowClick: function detailRowClick(row) {
      var that = this;
      var rows = that.detailForm.data.slice((that.detailForm.page - 1) * that.detailForm.pageSize, that.detailForm.page * that.detailForm.pageSize);
      var index = rows.indexOf(row);
      that.detailRowIndex = index;
      that.lastProduct = row;
      that.tipMessage = '产品名称：' + row.productName + '，规格型号：' + row.specificationModel;
    },
    rowClassName: function rowClassName(scope) {
      if (scope.row.returnQuantity > scope.row.normalQuantity) {
        scope.row.checked = false;
      } else {
        scope.row.checked = true;
      }

      if (!scope.row.checked) {
        return 'warning-row';
      }
    },
    barCodeSearch: function barCodeSearch() {
      var _this20 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        var that, parseQuery, parseRes, stockQuery, stockRes, rows, _stockQuery, _stockRes, _rows;

        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                that = _this20;

                if (that.form.manufacturerId) {
                  _context24.next = 4;
                  break;
                }

                that.$message.error('请选择经销商');
                return _context24.abrupt("return");

              case 4:
                if (!that.scanBarCode) {
                  _context24.next = 42;
                  break;
                }

                if (!(that.scanBarCode.substr(0, 2) === '01')) {
                  _context24.next = 25;
                  break;
                }

                _context24.prev = 6;
                parseQuery = {
                  di: null,
                  dipi: null
                };

                if (that.scanBarCode.length > 20) {
                  parseQuery.dipi = that.scanBarCode;
                } else {
                  parseQuery.di = that.scanBarCode;
                }

                _context24.next = 11;
                return parseBarCode(parseQuery);

              case 11:
                parseRes = _context24.sent;
                stockQuery = {
                  barCode: parseRes.barCode,
                  batch_number: parseRes.batch_number,
                  trackingCode: parseRes.tracking_code,
                  manufacturerId4: that.form.manufacturerId,
                  isVirtualWarehouse: 2,
                  page: 1,
                  pageSize: 1
                };
                _context24.next = 15;
                return listStockMain(stockQuery);

              case 15:
                stockRes = _context24.sent;

                if (stockRes.total === 1) {
                  rows = [];
                  stockRes.list = that.stockListFormat(stockRes.list);
                  stockRes.list.map(function (row) {
                    rows.push(_objectSpread({
                      id: null
                    }, row));
                  });
                  console.log('rows', rows);
                  that.stockAddToList(rows);
                } else if (stockRes.total > 1) {
                  that.$refs.SelectProductComponentRef.init({
                    manufacturerId: that.form.manufacturerId,
                    cusCode: null,
                    barCode: parseRes.barCode,
                    batchNumber: parseRes.batch_number,
                    trackingCode: parseRes.tracking_code
                  });
                } else if (stockRes.total === 0) {
                  that.$message.error('没有找到相关产品：' + that.scanBarCode);
                }

                that.scanBarCode = null;
                _context24.next = 23;
                break;

              case 20:
                _context24.prev = 20;
                _context24.t0 = _context24["catch"](6);
                that.$message.error(_context24.t0.message);

              case 23:
                _context24.next = 42;
                break;

              case 25:
                if (!(that.scanBarCode.substr(0, 2) === '99')) {
                  _context24.next = 40;
                  break;
                }

                _context24.prev = 26;
                _stockQuery = {
                  cusCode: that.scanBarCode,
                  batch_number: null,
                  trackingCode: null,
                  manufacturerId4: that.form.manufacturerId,
                  isVirtualWarehouse: 2,
                  page: 1,
                  pageSize: 1
                };
                _context24.next = 30;
                return listStockMain(_stockQuery);

              case 30:
                _stockRes = _context24.sent;

                if (_stockRes.total === 1) {
                  _rows = [];
                  _stockRes.list = that.stockListFormat(_stockRes.list);

                  _stockRes.list.map(function (row) {
                    _rows.push(_objectSpread({
                      id: null
                    }, row));
                  });

                  console.log('rows', _rows);
                  that.stockAddToList(_rows);
                } else if (_stockRes.total > 1) {
                  that.$refs.SelectProductComponentRef.init({
                    manufacturerId: that.form.manufacturerId,
                    cusCode: that.scanBarCode,
                    barCode: null,
                    batchNumber: null,
                    trackingCode: null
                  });
                } else if (_stockRes.total === 0) {
                  that.$message.error('没有找到相关产品：' + that.scanBarCode);
                }

                that.scanBarCode = null;
                _context24.next = 38;
                break;

              case 35:
                _context24.prev = 35;
                _context24.t1 = _context24["catch"](26);
                that.$message.error(_context24.t1.message);

              case 38:
                _context24.next = 42;
                break;

              case 40:
                that.scanBarCode = '01' + that.scanBarCode;
                that.barCodeSearch();

              case 42:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, null, [[6, 20], [26, 35]]);
      }))();
    },
    stockListFormat: function stockListFormat(rows) {
      var resultRows = [];
      rows.forEach(function (row, index) {
        resultRows.push({
          ID: row.ID,
          mainId: row.main_id,
          specsId: row.specs_id,
          inventoryId: row.ID,
          rowIndex: index,
          productNumber: row.specs.productNumber,
          productName: row.main.productName,
          specificationModel: row.specs.specificationModel,
          batchNumber: row.batch_number,
          salesQuantity: row.quantityUsed,
          stockQuantity: row.stock_quantity,
          normalQuantity: row.normalQuantity,
          consumedQuantity: row.consumedQuantity,
          receiptQuantity: row.receiptQuantity,
          issueLocking: row.issueLocking,
          salesPendingApproval: row.salesPendingApproval,
          productPackageLocking: row.productPackageLocking,
          unit: row.specs.unit,
          packUnit: row.specs.packUnit,
          packNum: row.specs.packNum,
          unitPrice: row.specs.wholesalePrice,
          registrationNumber: row.registrationNumber,
          manufacturerDate: row.manufacturer_date,
          validityDate: row.validity_date,
          expirationDate: row.main.expirationDate,
          productPlace: row.main.productPlace,
          brandName: row.main.brandName,
          sterilizationBatchNumber: row.sterilization_batch_number,
          sterilizationDate: row.sterilization_date,
          wholesalePurchasePrice: row.specs.wholesalePurchasePrice,
          consignmentPurchasePrice: row.specs.consignmentPurchasePrice,
          marketPrice: row.specs.marketPrice,
          consignmentPrice: row.specs.consignmentPrice,
          wholesalePrice: row.specs.wholesalePrice,
          sterilizationWays: row.specs.sterilizationWays,
          trackingCode: row.trackingCode || null,
          afterTaxPrice: Number(Number(row.afterTaxPrice).toFixed(2)),
          genericName: row.specs.genericName,
          manufacturerName: row.manufacturerName,
          medCode: row.specs.medCode,
          manufacturer: row.main.manufacturer,
          returnQuantity: 1,
          barCode: row.specs.barCode,
          sumPrice: Number(Number(row.returnQuantity * row.afterTaxPrice).toFixed(2))
        });
      });
      return resultRows;
    },
    pageChange: function pageChange(page) {
      var that = this;
      that.detailForm.page = page;
    },
    sizeChange: function sizeChange(pageSize) {
      var that = this;
      that.detailForm.page = 1;
      that.detaiilForm.pageSize = pageSize;
    }
  })
};